/**
 * Upload progress tracking for individual files
 * Used to manage upload state in the upload modal
 */
export const UploadProgressSchema = {
  file: "File", // File object from input
  name: "string", // Display name for the file
  progress: "number", // 0-100 percentage
  status: "string", // 'uploading' | 'success' | 'error'
  error: "string?", // Error message if status is 'error'
};

/**
 * Upload Status Constants
 */
export const UPLOAD_STATUS = {
  UPLOADING: "uploading",
  SUCCESS: "success",
  ERROR: "error",
};

/**
 * Example:
 * {
 *   "file": File {},
 *   "name": "document.pdf",
 *   "progress": 75,
 *   "status": "uploading",
 *   "error": null
 * }
 */
